export default __webpack_public_path__ + "4548e08ae5861c68095767ed3190e211.png";